export const useStyles = theme => ({
  headerRoot: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerImg: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '200px',
    },
  },
  headerButton: {
    borderRadius: '10px',
    color: '#F0B310',
    padding: '10px',
    backgroundColor: '#FFFFFF !important',
  },
});
